import { useState } from "react";
import DefaultFooter from "../components/default-footer";
import Header1 from "../components/default-header";
import DatePicker, { DateObject } from "react-multi-date-picker";
import Slider from "rc-slider";
import toursData from "./../data/tours";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useParams } from "react-router-dom";
import Tours from "./../components/Tours";
import "photoswipe/dist/photoswipe.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import GoogleMapReact from "google-map-react";
import { FC } from "react";
import ModalVideo from "../components/ModalVideo";
import SectionSubscribe from "../components/sectionSubscribe";

const counters = [
    { name: "Adults", defaultValue: 2 },
    { name: "Children", defaultValue: 1 },
    { name: "Rooms", defaultValue: 1 },
  ];

  type CounterProps = {
    name: string;
    defaultValue: number;
    onCounterChange: (name: string, value: number) => void;
  };

  const Counter = ({ name, defaultValue, onCounterChange }: CounterProps) => {
    const [count, setCount] = useState(defaultValue);
    const incrementCount = () => {
      setCount(count + 1);
      onCounterChange(name, count + 1);
    };
    const decrementCount = () => {
      if (count > 0) {
        setCount(count - 1);
        onCounterChange(name, count - 1);
      }
    };
  
    return (
      <>
        <div className="row y-gap-10 justify-between items-center">
          <div className="col-auto">
            <div className="text-15 lh-12 fw-500">{name}</div>
            {name === "Children" && (
              <div className="text-14 lh-12 text-light-1 mt-5">Ages 0 - 17</div>
            )}
          </div>
          {/* End .col-auto */}
          <div className="col-auto">
            <div className="d-flex items-center js-counter">
              <button
                className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-down"
                onClick={decrementCount}
              >
                <i className="icon-minus text-12" />
              </button>
              {/* decrement button */}
              <div className="flex-center size-20 ml-15 mr-15">
                <div className="text-15 js-count">{count}</div>
              </div>
              {/* counter text  */}
              <button
                className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-up"
                onClick={incrementCount}
              >
                <i className="icon-plus text-12" />
              </button>
              {/* increment button */}
            </div>
          </div>
          {/* End .col-auto */}
        </div>
        {/* End .row */}
        <div className="border-top-light mt-24 mb-24" />
      </>
    );
  };

type AnyReactComponentProps = {
    lat: number;
    lng: number;
    text: string;
  };
  
  const AnyReactComponent: FC<AnyReactComponentProps> = ({ lat, lng, text }) => (
    <div>
       {text} <br />
      (lat: {lat}, lng: {lng})
    </div>
  );

const SinglePromotion = () => {

    const [guestCounts, setGuestCounts] = useState({
        Adults: 2,
        Children: 1,
        Rooms: 1,
      });
      const handleCounterChange = (name:any, value:any) => {
        setGuestCounts((prevState) => ({ ...prevState, [name]: value }));
      };
    const [dates, setDates] = useState([
        new DateObject().setDay(5),
        new DateObject().setDay(14).add(1, "month"),
      ]);

    const [isOpen, setOpen] = useState(false);
    const { id } = useParams<{ id: string }>(); // id est une string
    const tour = toursData.find((item) => item.id === Number(id)) || toursData[0];

    const defaultProps = {
        center: {
          lat: 10.99835602,
          lng: 77.01502627,
        },
        zoom: 11,
      };

    const itineraryContent = [
        {
          id: 1,
          targetCollapse: "item_1",
          itemNo: "1",
          title: "Windsor Castle",
          img: "/img/tours/list.png",
          content: `Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years and the largest, continuously occupied castle in Europe.`,
          classShowHide: "",
        },
        {
          id: 2,
          targetCollapse: "item_2",
          itemNo: "2",
          title: "St. George's Chapel",
          img: "/img/tours/list.png",
          content: `Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years and the largest, continuously occupied castle in Europe.`,
          classShowHide: "show",
        },
        {
          id: 3,
          targetCollapse: "item_3",
          itemNo: "3",
          title: "The Roman Baths",
          img: "/img/tours/list.png",
          content: `Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years and the largest, continuously occupied castle in Europe.`,
          classShowHide: "",
        },
        {
          id: 4,
          targetCollapse: "item_4",
          itemNo: "4",
          title: "Stonehenge",
          img: "/img/tours/list.png",
          content: `Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years and the largest, continuously occupied castle in Europe.`,
          classShowHide: "",
        },
      ];

    const reviewProgressContent = [
        { id: 1, reviewReason: "Location", ratings: "9.4", progressPercent: "90%" },
        { id: 2, reviewReason: "Staff", ratings: "8.4", progressPercent: "84%" },
        {
          id: 3,
          reviewReason: "Cleanliness",
          ratings: "9.4",
          progressPercent: "90%",
        },
        {
          id: 4,
          reviewReason: "Value for money",
          ratings: "8",
          progressPercent: "80%",
        },
        { id: 5, reviewReason: "Comfort", ratings: "9.4", progressPercent: "90%" },
        {
          id: 6,
          reviewReason: "Facilities",
          ratings: "8.5",
          progressPercent: "85%",
        },
        {
          id: 7,
          reviewReason: "Free WiFi",
          ratings: "9.4",
          progressPercent: "90%",
        },
      ];
    const reviewGalleryImg = [
        "/img/testimonials/1/1.png",
        "/img/testimonials/1/2.png",
        "/img/testimonials/1/3.png",
        "/img/testimonials/1/4.png",
      ];

    const replyReviewContent = [
        {
          id: 1,
          reasonOfreview: "Location",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
        {
          id: 2,
          reasonOfreview: "Staff",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
        {
          id: 3,
          reasonOfreview: "Cleanliness",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
        {
          id: 4,
          reasonOfreview: "Value for money",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
        {
          id: 5,
          reasonOfreview: "Comfort",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
        {
          id: 6,
          reasonOfreview: "Facilities",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
        {
          id: 7,
          reasonOfreview: "Free WiFi",
          ratings: (
            <>
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
              <div className="icon-star text-10 text-yellow-1" />
            </>
          ),
        },
      ];
    

    return (
        <>
          {/* End Page Title */}
    
          <div className="header-margin"></div>
          {/* header top margin */}
    
          <Header1 />
          {/* End Header 1 */}
    
  
    
          <section className="pt-40">
            <div className="container">
              <div className="row y-gap-20 justify-between items-end">
                <div className="col-auto">
                  <h1 className="text-30 fw-600">{tour?.title}</h1>
                  <div className="row x-gap-20 y-gap-20 items-center pt-10">
                    <div className="col-auto">
                      <div className="d-flex items-center">
                        <div className="d-flex x-gap-5 items-center">
                          <i className="icon-star text-10 text-yellow-1"></i>
    
                          <i className="icon-star text-10 text-yellow-1"></i>
    
                          <i className="icon-star text-10 text-yellow-1"></i>
    
                          <i className="icon-star text-10 text-yellow-1"></i>
    
                          <i className="icon-star text-10 text-yellow-1"></i>
                        </div>
    
                        <div className="text-14 text-light-1 ml-10">
                          {tour?.numberOfReviews} reviews
                        </div>
                      </div>
                    </div>
    
                    <div className="col-auto">
                      <div className="row x-gap-10 items-center">
                        <div className="col-auto">
                          <div className="d-flex x-gap-5 items-center">
                            <i className="icon-placeholder text-16 text-light-1"></i>
                            <div className="text-15 text-light-1">
                              {tour?.location}
                            </div>
                          </div>
                        </div>
    
                        <div className="col-auto">
                          <button
                            data-x-click="mapFilter"
                            className="text-blue-1 text-15 underline"
                          >
                            Show on map
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End .col */}
    
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-10">
                    <div className="col-auto">
                      <button className="button px-15 py-10 -blue-1">
                        <i className="icon-share mr-10"></i>
                        Share
                      </button>
                    </div>
    
                    <div className="col-auto">
                      <button className="button px-15 py-10 -blue-1 bg-light-2">
                        <i className="icon-heart mr-10"></i>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                {/* End .col */}
              </div>
              {/* End .row */}
            </div>
            {/* End .container */}
          </section>
          {/* End gallery grid wrapper */}
    
          <ModalVideo isOpen={isOpen} videoId="oqNZOOWF8qM" setIsOpen={setOpen} />
  <section className="pt-40 js-pin-container">
    <div className="container">
      <div className="row y-gap-30">
        <div className="col-xl-8">
          <div className="relative d-flex justify-center overflow-hidden js-section-slider">
            <Swiper
              modules={[Navigation]}
              loop={true}
              navigation={{
                nextEl: ".js-img-next",
                prevEl: ".js-img-prev",
              }}
            >
              {tour?.slideImg?.map((slide: string, i: number) => (
                <SwiperSlide key={i}>
                  <img
                    width={451}
                    height={450}
                    src={slide}
                    alt="image"
                    style={{ height: "501px" }}
                    className="rounded-4 col-12 cover object-cover"
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            <Gallery>
              {tour?.slideImg?.map((slide: string, i: number) => (
                <div
                  className="absolute px-10 py-10 col-12 h-full d-flex justify-end items-end z-2 bottom-0 end-0"
                  key={i}
                >
                  <Item original={slide} thumbnail={slide} width={451} height={450}>
                    {({ ref, open }) => (
                      <div
                        className="button -blue-1 px-24 py-15 bg-white text-dark-1 js-gallery"
                        ref={ref as unknown as React.RefObject<HTMLDivElement>}
                        onClick={open}
                        role="button"
                      >
                        See All Photos
                      </div>
                    )}
                  </Item>
                </div>
              ))}
            </Gallery>

            <div className="absolute h-full col-11">
              <button className="section-slider-nav -prev flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-img-prev">
                <i className="icon icon-chevron-left text-12" />
              </button>
              <button className="section-slider-nav -next flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-img-next">
                <i className="icon icon-chevron-right text-12" />
              </button>
            </div>
            {/* End prev nav button wrapper */}
          </div>
          {/* End relative */}

          {/* slider gallery */}
          <h3 className="text-22 fw-500 mt-40">Tour snapshot</h3>
          <div className="row y-gap-30 justify-between pt-20">
      <div className="col-md-auto col-6">
        <div className="d-flex">
          <i className="icon-clock text-22 text-blue-1 mr-10"></i>
          <div className="text-15 lh-15">
            Duration:
            <br /> 11h
          </div>
        </div>
      </div>
      {/* End .col */}

      <div className="col-md-auto col-6">
        <div className="d-flex">
          <i className="icon-customer text-22 text-blue-1 mr-10"></i>
          <div className="text-15 lh-15">
            Group size:
            <br /> 52
          </div>
        </div>
      </div>
      {/* End .col */}

      <div className="col-md-auto col-6">
        <div className="d-flex">
          <i className="icon-route text-22 text-blue-1 mr-10"></i>
          <div className="text-15 lh-15">
            Near public
            <br /> transportation
          </div>
        </div>
      </div>
      {/* End .col */}

      <div className="col-md-auto col-6">
        <div className="d-flex">
          <i className="icon-access-denied text-22 text-blue-1 mr-10"></i>
          <div className="text-15 lh-15">
            Free cancellation <br />
            <a href="#" className="text-blue-1 underline">
              Learn more
            </a>
          </div>
        </div>
      </div>
      {/* End .col */}
    </div>
          {/* End toursnapshot */}

          <div className="border-top-light mt-40 mb-40"></div>
          <div className="row x-gap-40 y-gap-40">
        <div className="col-12">
          <h3 className="text-22 fw-500">Overview</h3>

          <p className="text-dark-1 text-15 mt-20">
            Unless you hire a car, visiting Stonehenge, Bath, and Windsor Castle
            in one day is next to impossible. Designed specifically for
            travelers with limited time in London, this tour allows you to check
            off a range of southern England&lsquo;s historical attractions in
            just one day by eliminating the hassle of traveling between each one
            independently. Travel by comfortable coach and witness your guide
            bring each UNESCO World Heritage Site to life with commentary. Plus,
            all admission tickets are included in the tour price.
          </p>

          <a
            href="#"
            className="d-block text-14 text-blue-1 fw-500 underline mt-10"
          >
            Show More
          </a>
        </div>

        <div className="col-md-6">
          <h5 className="text-16 fw-500">Available languages</h5>
          <div className="text-15 mt-10">
            German, Chinese, Portuguese, Japanese, English, Italian, Chinese,
            French, Spanish
          </div>
        </div>

        <div className="col-md-6">
          <h5 className="text-16 fw-500">Cancellation policy</h5>
          <div className="text-15 mt-10">
            For a full refund, cancel at least 24 hours in advance of the start
            date of the experience.
          </div>
        </div>

        <div className="col-12">
          <h5 className="text-16 fw-500">Highlights</h5>
          <ul className="list-disc text-15 mt-10">
            <li>
              Travel between the UNESCO World Heritage sites aboard a
              comfortable coach
            </li>
            <li>Explore with a guide to delve deeper into the history</li>
            <li>Great for history buffs and travelers with limited time</li>
          </ul>
        </div>
      </div>

      <div className="mt-40 border-top-light">
        <div className="row x-gap-40 y-gap-40 pt-40">
          <div className="col-12">
            <h3 className="text-22 fw-500">What&lsquo;s Included</h3>

            <div className="row x-gap-40 y-gap-40 pt-20">
              <div className="col-md-6">
                <div className="text-dark-1 text-15">
                  <i className="icon-check text-10 mr-10"></i> Entry ticket to
                  Harry Potter Warner Bros Studio Tour London
                </div>
                <div className="text-dark-1 text-15">
                  <i className="icon-check text-10 mr-10"></i> Return transfers
                  in air-conditioned coach
                </div>
              </div>

              <div className="col-md-6">
                <div className="text-dark-1 text-15">
                  <i className="icon-close text-green-2 text-10 mr-10"></i> Food
                  and drinks
                </div>
                <div className="text-dark-1 text-15">
                  <i className="icon-close text-green-2 text-10 mr-10"></i>{" "}
                  Gratuities
                </div>
                <div className="text-dark-1 text-15">
                  <i className="icon-close text-green-2 text-10 mr-10"></i>{" "}
                  Digital guide available in 10 different languages at
                  additional cost
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
          {/* End  Overview */}
        </div>
        {/* End .col-xl-8 */}

        <div className="col-xl-4">
        <div className="d-flex justify-end js-pin-content">
      <div className="w-360 lg:w-full d-flex flex-column items-center">
        <div className="px-30 py-30 rounded-4 border-light bg-white shadow-4">
          <div className="text-14 text-light-1">
            From{" "}
            <span className="text-20 fw-500 text-dark-1 ml-5">
              US${tour?.price}
            </span>
          </div>
          {/* End div */}

          <div className="row y-gap-20 pt-30">
            
          <div className="col-12">
        <div className="searchMenu-date px-20 py-10 border-light rounded-4 -right js-form-dd js-calendar">
          <div>
            <h4 className="text-15 fw-500 ls-2 lh-16">Date</h4>
                <div className="text-15 text-light-1 ls-2 lh-16 custom_dual_datepicker">
      <DatePicker
        inputClass="custom_input-picker"
        containerClassName="custom_container-picker"
        value={dates}
        onChange={setDates}
        numberOfMonths={2}
        offsetY={10}
        range
        rangeHover
        format="MMMM DD"
      />
    </div>
          </div>
        </div>
        {/* End check-in-out */}
      </div>
      {/* End .col-12 */}

      <div className="col-12">
      <div className="searchMenu-guests px-20 py-10 border-light rounded-4 js-form-dd js-form-counters">
      <div
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
        data-bs-offset="0,22"
      >
        <h4 className="text-15 fw-500 ls-2 lh-16">Number of travelers</h4>
        <div className="text-15 text-light-1 ls-2 lh-16">
          <span className="js-count-adult">{guestCounts.Adults}</span> adults -{" "}
          <span className="js-count-child">{guestCounts.Children}</span>{" "}
          childeren - <span className="js-count-room">{guestCounts.Rooms}</span>{" "}
          room
        </div>
      </div>
      {/* End guest */}

      <div className="shadow-2 dropdown-menu min-width-400">
        <div className="bg-white px-30 py-30 rounded-4 counter-box">
          {counters.map((counter) => (
            <Counter
              key={counter.name}
              name={counter.name}
              defaultValue={counter.defaultValue}
              onCounterChange={handleCounterChange}
            />
          ))}
        </div>
      </div>
    </div>
        {/* End guest */}
      </div>
      {/* End .col-12 */}

      <div className="col-12">
        <a
          href="/booking-page"
          className="button -dark-1 py-15 px-35 h-60 col-12 rounded-4 bg-blue-1 text-white"
        >
          Book Now
        </a>
      </div>
      {/* End .col-12 */}

          </div>
          {/* End div */}

          <div className="d-flex items-center pt-20">
            <div className="size-40 flex-center bg-light-2 rounded-full">
              <i className="icon-heart text-16 text-green-2" />
            </div>
            <div className="text-14 lh-16 ml-10">
              94% of travelers recommend this experience
            </div>
          </div>
        </div>
        {/* End px-30 */}

        <div className="px-30">
          <div className="text-14 text-light-1 mt-30">
            Not sure? You can cancel this reservation up to 24 hours in advance
            for a full refund.
          </div>
        </div>
        {/* End div */}
      </div>
    </div>
        </div>
        {/* End .col-xl-4 */}
      </div>
      {/* End .row */}
    </div>
    {/* End container */}
  </section>
    
          {/* End single page content */}
    
          <section className="pt-40">
            <div className="container">
              <div className="pt-40 border-top-light">
                <div className="row x-gap-40 y-gap-40">
                  <div className="col-auto">
                    <h3 className="text-22 fw-500">Important information</h3>
                  </div>
                </div>
                {/* End row */}
                
                <div className="row x-gap-40 y-gap-40 justify-between pt-20">
      <div className="col-lg-4 col-md-6">
        <div className="fw-500 mb-10">Inclusions</div>
        <ul className="list-disc">
          <li>Superior Coach, Wi-Fi and USB Charging On-board</li>
          <li>Expert guide</li>
          <li>Admission to Windsor Castle (if option selected)</li>
          <li>Admission to Stonehenge</li>
        </ul>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="fw-500 mb-10">Departure details</div>
        <div className="text-15">
          Departures from 01st April 2022: Tour departs at 8 am (boarding at
          7.30 am), Victoria Coach Station Gate 1-5
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="fw-500 mb-10">Know before you go</div>
        <ul className="list-disc">
          <li>Duration: 11h</li>
          <li>Mobile tickets accepted</li>
          <li>Instant confirmation</li>
        </ul>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="fw-500 mb-10">Exclusions</div>
        <ul className="list-disc">
          <li>Hotel pick-up and drop-off</li>
          <li>Gratuities</li>
          <li>Lunch</li>
        </ul>
      </div>

      <div className="col-12">
        <div className="fw-500 mb-10">Additional information</div>
        <ul className="list-disc">
          <li>Confirmation will be received at time of booking</li>
          <li>
            Departs at 8am (boarding at 7.30am), Victoria Coach Station Gate
            1-5, 164 Buckingham Palace Road, London, SW1W 9TP
          </li>
          <li>
            As Windsor Castle is a working royal palace, sometimes the entire
            Castle or the State Apartments within the Castle need to be closed
            at short notice. (if selected this option)
          </li>
          <li>
            Stonehenge is closed on 21 June due to the Summer Solstice. During
            this time, we will instead visit the Avebury Stone Circle.
          </li>
          <li>Please note: the tour itinerary and order may change</li>
        </ul>
      </div>
    </div>
              </div>
              {/* End pt-40 */}
            </div>
            {/* End .container */}
          </section>
          {/* End important info */}
    
          <section className="border-top-light  mt-40 pt-40">
            <div className="container">
              <h3 className="text-22 fw-500 mb-20">Itinerary</h3>
              <div className="row y-gap-30">
      <div className="col-lg-4">
        <div className="relative">
          <div className="border-test" />
          <div className="accordion -map row y-gap-20" id="itineraryContent">
          {itineraryContent.map((item) => (
        <div className="col-12" key={item.id}>
          <div className="accordion__item ">
            <div className="d-flex">
              <div className="accordion__icon size-40 flex-center bg-blue-2 text-blue-1 rounded-full">
                <div className="text-14 fw-500">{item.itemNo}</div>
              </div>
              {/* End item number */}

              <div className="ml-20">
                <div className="text-16 lh-15 fw-500">{item.title}</div>
                <div className="text-14 lh-15 text-light-1 mt-5">
                  Stop: 60 minutes - Admission included
                </div>
                <div
                  className={`accordion-collapse collapse ${item.classShowHide}`}
                  id={item.targetCollapse}
                  data-bs-parent="#itineraryContent"
                >
                  <div className="pt-15 pb-15">
                    <img
                      width={350}
                      height={160}
                      src={item.img}
                      alt="image"
                      className="rounded-4 mt-15"
                    />
                    <div className="text-14 lh-17 mt-15">{item.content}</div>
                  </div>
                </div>
                {/* End accordion conent */}

                <div
                  className="accordion__button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${item.targetCollapse}`}
                >
                  <button className="d-block lh-15 text-14 text-blue-1 underline fw-500 mt-5">
                    See details &amp; photo
                  </button>
                </div>
                {/* End accordion button */}
              </div>
            </div>
          </div>
        </div>
      ))}
          </div>
        </div>
      </div>
      {/* End col-lg-4 */}

      <div className="col-lg-8">
        <div className="map rounded-4 overflow-hidden">
        <GoogleMapReact
      bootstrapURLKeys={{ key: "" }}
      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}
    >
      <AnyReactComponent lat={59.955413} lng={30.337844} text="My Marker" />
    </GoogleMapReact>
        </div>
      </div>
      {/* End col-lg-8 */}
    </div>
            </div>
          </section>
          {/* End Itinerary */}
    
          <section className="mt-40">
            <div className="container ">
              <div className="pt-40 border-top-light">
                <div className="row y-gap-20">
                  <div className="col-lg-4">
                    <h2 className="text-22 fw-500">
                      FAQs about
                      <br /> The Crown Hotel
                    </h2>
                  </div>
                  {/* End .row */}
    
                  <div className="col-lg-8">
                    <div
                      className="accordion -simple row y-gap-20 js-accordion"
                      id="Faq1"
                    >
                      hjfdhjd
                    </div>
                  </div>
                  {/* End .col */}
                </div>
                {/* End .row */}
              </div>
              {/* End .pt-40 */}
            </div>
            {/* End .container */}
          </section>
          {/* End Faq about sections */}
    
          <section className="mt-40 border-top-light pt-40">
            <div className="container">
              <div className="row y-gap-40 justify-between">
                <div className="col-xl-3">
                  <h3 className="text-22 fw-500">Guest reviews</h3>
                 
                  <div className="d-flex items-center mt-20">
        <div className="flex-center bg-blue-1 rounded-4 size-70 text-22 fw-600 text-white">
          4.8
        </div>
        <div className="ml-20">
          <div className="text-16 text-dark-1 fw-500 lh-14">Exceptional</div>
          <div className="text-15 text-light-1 lh-14 mt-4">3,014 reviews</div>
        </div>
      </div>
      {/* End .d-flex */}

      <div className="row y-gap-20 pt-20">
        {reviewProgressContent.map((item) => (
          <div className="col-12" key={item.id}>
            <div className="d-flex items-center justify-between">
              <div className="text-15 fw-500">{item.reviewReason}</div>
              <div className="text-15 text-light-1">{item.ratings}</div>
            </div>
            <div className="progressBar mt-10">
              <div className="progressBar__bg bg-blue-2" />
              <div
                className="progressBar__bar bg-dark-1"
                style={{ width: item.progressPercent }}
              />
            </div>
          </div>
        ))}

        {/* End .col-md-4 */}
      </div>
      {/* End .row */}
                  {/* End review with progress */}
                </div>
                {/* End col-xl-3 */}
    
                <div className="col-xl-8">
                <div className="row y-gap-40">
      <div className="col-lg-12">
        <div className="row x-gap-20 y-gap-20 items-center">
          <div className="col-auto">
            <img
              width={60}
              height={60}
              src="/img/avatars/2.png"
              alt="image"
            />
          </div>
          <div className="col-auto">
            <div className="fw-500 lh-15">Tonko</div>
            <div className="text-14 text-light-1 lh-15">March 2022</div>
          </div>
        </div>
        {/* End .row */}

        <h5 className="fw-500 text-blue-1 mt-20">9.2 Superb</h5>
        <p className="text-15 text-dark-1 mt-10">
          Nice two level apartment in great London location. Located in quiet
          small street, but just 50 meters from main street and bus stop. Tube
          station is short walk, just like two grocery stores.{" "}
        </p>

        <Gallery>
      <div className="row x-gap-30 y-gap-30 pt-20">
        {reviewGalleryImg.map((img, i) => (
          <div className="col-auto" key={i}>
            <Item original={img} thumbnail={img} width={110} height={110}>
              {({ ref, open }) => (
                <img
                  width={110}
                  height={110}
                  src={img}
                  ref={ref}
                  onClick={open}
                  alt="image"
                  role="button"
                  className="rounded-4"
                />
              )}
            </Item>
          </div>
        ))}
      </div>
    </Gallery>

        <div className="d-flex x-gap-30 items-center pt-20">
          <button className="d-flex items-center text-blue-1">
            <i className="icon-like text-16 mr-10" />
            Helpful
          </button>
          <button className="d-flex items-center text-light-1">
            <i className="icon-dislike text-16 mr-10" />
            Not helpful
          </button>
        </div>
      </div>
      {/* End .col */}

      <div className="col-lg-12">
        <div className="row x-gap-20 y-gap-20 items-center">
          <div className="col-auto">
            <img
              width={60}
              height={60}
              src="/img/avatars/2.png"
              alt="image"
            />
          </div>
          <div className="col-auto">
            <div className="fw-500 lh-15">Tonko</div>
            <div className="text-14 text-light-1 lh-15">March 2022</div>
          </div>
        </div>
        {/* End .row */}
        <h5 className="fw-500 text-blue-1 mt-20">9.2 Superb</h5>
        <p className="text-15 text-dark-1 mt-10">
          Nice two level apartment in great London location. Located in quiet
          small street, but just 50 meters from main street and bus stop. Tube
          station is short walk, just like two grocery stores.{" "}
        </p>

        <Gallery>
      <div className="row x-gap-30 y-gap-30 pt-20">
        {reviewGalleryImg.map((img, i) => (
          <div className="col-auto" key={i}>
            <Item original={img} thumbnail={img} width={110} height={110}>
              {({ ref, open }) => (
                <img
                  width={110}
                  height={110}
                  src={img}
                  ref={ref}
                  onClick={open}
                  alt="image"
                  role="button"
                  className="rounded-4"
                />
              )}
            </Item>
          </div>
        ))}
      </div>
    </Gallery>

        <div className="d-flex x-gap-30 items-center pt-20">
          <button className="d-flex items-center text-blue-1">
            <i className="icon-like text-16 mr-10" />
            Helpful
          </button>
          <button className="d-flex items-center text-light-1">
            <i className="icon-dislike text-16 mr-10" />
            Not helpful
          </button>
        </div>
      </div>
      {/* End .col */}

      <div className="col-lg-12">
        <div className="row x-gap-20 y-gap-20 items-center">
          <div className="col-auto">
            <img
              width={60}
              height={60}
              src="/img/avatars/2.png"
              alt="image"
            />
          </div>
          <div className="col-auto">
            <div className="fw-500 lh-15">Tonko</div>
            <div className="text-14 text-light-1 lh-15">March 2022</div>
          </div>
        </div>
        {/* End .row */}

        <h5 className="fw-500 text-blue-1 mt-20">9.2 Superb</h5>
        <p className="text-15 text-dark-1 mt-10">
          Nice two level apartment in great London location. Located in quiet
          small street, but just 50 meters from main street and bus stop. Tube
          station is short walk, just like two grocery stores.{" "}
        </p>
        <div className="d-flex x-gap-30 items-center pt-20">
          <button className="d-flex items-center text-blue-1">
            <i className="icon-like text-16 mr-10" />
            Helpful
          </button>
          <button className="d-flex items-center text-light-1">
            <i className="icon-dislike text-16 mr-10" />
            Not helpful
          </button>
        </div>
      </div>
      {/* End .col */}

      <div className="col-lg-12">
        <div className="row x-gap-20 y-gap-20 items-center">
          <div className="col-auto">
            <img
              width={60}
              height={60}
              src="/img/avatars/2.png"
              alt="image"
            />
          </div>
          <div className="col-auto">
            <div className="fw-500 lh-15">Tonko</div>
            <div className="text-14 text-light-1 lh-15">March 2022</div>
          </div>
        </div>
        {/* End .row */}

        <h5 className="fw-500 text-blue-1 mt-20">9.2 Superb</h5>
        <p className="text-15 text-dark-1 mt-10">
          Nice two level apartment in great London location. Located in quiet
          small street, but just 50 meters from main street and bus stop. Tube
          station is short walk, just like two grocery stores.{" "}
        </p>
        <div className="d-flex x-gap-30 items-center pt-20">
          <button className="d-flex items-center text-blue-1">
            <i className="icon-like text-16 mr-10" />
            Helpful
          </button>
          <button className="d-flex items-center text-light-1">
            <i className="icon-dislike text-16 mr-10" />
            Not helpful
          </button>
        </div>
      </div>
      {/* End .col */}

      <div className="col-auto">
        <a href="#" className="button -md -outline-blue-1 text-blue-1">
          Show all 116 reviews{" "}
          <div className="icon-arrow-top-right ml-15"></div>
        </a>
      </div>
      {/* End .col-auto */}
    </div>
                </div>
                {/* End col-xl-8 */}
              </div>
              {/* End .row */}
            </div>
            {/* End .container */}
            {/* End container */}
          </section>
          {/* End Review section */}
    
          <section className="mt-40 border-top-light pt-40">
            <div className="container">
              <div className="row y-gap-30 justify-between">
                <div className="col-xl-3">
                  <div className="row">
                    <div className="col-auto">
                      <h3 className="text-22 fw-500">Leave a Reply</h3>
                      <p className="text-15 text-dark-1 mt-5">
                        Your email address will not be published.
                      </p>
                    </div>
                  </div>
                  {/* End .row */}
    
                  <div className="row y-gap-30 pt-30">
      {replyReviewContent.map((item) => (
        <div className="col-sm-6" key={item.id}>
          <div className="text-15 lh-1 fw-500">{item.reasonOfreview}</div>
          <div className="d-flex x-gap-5 items-center pt-10">
            {item.ratings}
          </div>
        </div>
      ))}
    </div>
                  {/* End ReplyFormReview */}
                </div>
                {/* End .col-xl-3 */}
    
                <div className="col-xl-8">
                <form className="row y-gap-30 pt-20">
      <div className="col-xl-6">
        <div className="form-input ">
          <input type="text" required />
          <label className="lh-1 text-16 text-light-1">Text</label>
        </div>
      </div>
      {/* End .col */}

      <div className="col-xl-6">
        <div className="form-input ">
          <input type="text" required />
          <label className="lh-1 text-16 text-light-1">Email</label>
        </div>
      </div>
      {/* End .col */}

      <div className="col-12">
        <div className="form-input ">
          <textarea required rows={4} defaultValue={""} />
          <label className="lh-1 text-16 text-light-1">
            Write Your Comment
          </label>
        </div>
      </div>
      {/* End .col */}

      <div className="col-auto">
        <button
          type="submit"
          className="button -md -dark-1 bg-blue-1 text-white"
        >
          Post Comment <div className="icon-arrow-top-right ml-15" />
        </button>
      </div>
      {/* End .col */}
    </form>
                </div>
                {/* End .col-xl-8 */}
              </div>
              {/* End .row */}
            </div>
            {/* End .container */}
          </section>
          {/* End Reply Comment box section */}
    
    
          <DefaultFooter />
        </>
      );

  };
  
  export default SinglePromotion;
  